<template>

  <div>
    <list-filters
      :trigger-filter.sync="triggerFilter"
      :data-filter.sync="dataFilter"
    />

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Tampilkan</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entri</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
          <div class="d-flex align-items-center justify-content-end">
            <h6 class="mr-1" v-if="attr != 'm4h5s5523' && attr != 'a4d5m5221'">Lihat Data Sebagai</h6>
              <v-select
                v-if="attr != 'm4h5s5523' && attr != 'a4d5m5221'"
                v-model="searchQuery"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="lihatSebagaiOptions.options"
                class="w-50"
                :reduce="val => val.value"
                :clearable="false"
                placeholder="Lihat Sebagai"
              />
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refUserListTable"
        class="position-relative"
        :items="fetchDatas"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Tidak ada data yang ditemukan"
        :sort-desc.sync="isSortDirDesc"
        style="text-align:center;"
      >

        <!-- Column: User -->
        <template #cell(status)="data">
          <b-media vertical-align="center">
              <div>
                <a href="#" @click="$bvModal.show(`bv-modal-admin-status${data.item.uuid}`)" v-if="$can('all','manage')"><b-badge pill :variant="'light-'+data.item.color" >{{ data.item.status }}</b-badge></a>
                 <a href="#" v-if="!$can('all','manage')"><b-badge pill :variant="'light-'+data.item.color" >{{ data.item.status }}</b-badge></a>
                <b-modal :id="`bv-modal-admin-status${data.item.uuid}`" hide-footer>
                  <template #modal-title>
                    Status Hasil Sidang
                  </template>
                  <div class="d-block">
                      <v-select
                        id="status_hasil_sidang"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :reduce="val => val.value"
                        :options="statusHasilSidangOption.options"
                        v-model="status_hasil_sidang_id"
                        placeholder="Pilih Status Hasil Sidang"
                      />
                  </div>
                  <div class="d-flex justify-content-center">
                    <b-button variant="success" class="mt-3 mr-1" @click="updateStatusHasilSidangByAdmin(data.item.uuid)">Ya</b-button>
                    <b-button variant="danger" class="mt-3" @click="$bvModal.hide(`bv-modal-admin-status${data.item.uuid}`)">Batal</b-button>
                  </div>
                </b-modal>
              </div>
          </b-media>
        </template>

        <template #cell(catatan)="data">
          <b-media vertical-align="center">
              <b-badge pill :variant="'light-danger'" >{{ data.item.catatan }}</b-badge>
          </b-media>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div class="d-flex justify-content-center">
            <!-- // Updated by Rio Ramadhan date: comment: button untuk role mahasiswa -->
            <b-button class="mr-1 btn-icon btn btn-relief-primary" variant="primary" :to="{ name: 'hasil-sidang-edit', params: { uuid: data.item.uuid } }" title="Ubah Data"
              v-if="(data.item.role == 'pembimbing' && data.item.pembimbing_utama == 'ya') || (data.item.role == 'penguji')"
            >
              <feather-icon icon="EditIcon" />
            </b-button>

            <b-button class="mr-1 btn-icon btn btn-relief-primary" variant="primary" :to="{ name: 'hasil-sidang-edit', params: { uuid: data.item.uuid } }" title="Ubah Data"
              v-if="data.item.role == 'mahasiswa' && data.item.status_hasil_sidang_id != 4 && data.item.status_hasil_sidang_id != 6"
            >
              <feather-icon icon="EditIcon" />
            </b-button>

            <b-button class="mr-1 btn-icon btn btn-relief-primary" variant="primary" :to="{ name: 'hasil-sidang-edit', params: { uuid: data.item.uuid } }" title="Ubah Data"
            v-if="$can('manage','all-content')"
            >
            <feather-icon icon="EditIcon" />
            </b-button>

           
            <b-button
              class="mr-1 btn-icon btn btn-relief-danger"
              v-b-modal="'modal-batalkan-ujian-' + data.item.uuid"
              variant="danger"
              title="Batalkan Ujian"
              v-if="$can('manage', 'all-content') || (data.item.role == 'pembimbing' && data.item.pembimbing_utama == 'ya' && data.item.status_hasil_sidang_id == 4)"
            >
              <feather-icon icon="XCircleIcon" />
            </b-button>
            <b-modal :id="'modal-batalkan-ujian-' + data.item.uuid" centered title="Konfirmasi" :hide-footer="true">
              <center><p>Apakah anda yakin ingin membatalkan sidang ini ?</p></center>
              <center>
                <b-form-textarea
                  id="catatan"
                  v-model="catatan_pembatalan"
                  trim
                  placeholder="Catatan Pembatalan"
                  rows="3"
                />
              </center>
              <div class="d-flex justify-content-center mt-2">
                <b-button variant="success" class="mr-1" @click="batalkanUjian(data.item.uuid, catatan_pembatalan)">Ya</b-button>
                <b-button variant="danger" @click="$bvModal.hide('modal-batalkan-ujian-' + data.item.uuid)">Tidak</b-button>
              </div>
            </b-modal>

            <b-button class="mr-1 btn-icon btn btn-relief-primary" variant="warning" :to="{ name: 'hasil-sidang-perubahan-nilai-edit', params: { uuid: data.item.uuid } }" title="Ubah Nilai"
            v-if="data.item.role == 'kaprodi' && (data.item.status_hasil_sidang_id == 2 || data.item.status_hasil_sidang_id == 3)"
            >
              <feather-icon icon="EditIcon" />
            </b-button>

            <b-button
              class="mr-1 btn-icon btn btn-relief-primary"
              v-b-modal="'modal-download-' + data.item.uuid"
              variant="outline-primary"
              title="Download File"
              v-if="data.item.status_hasil_sidang_id == 5"
            >
            <!-- v-if="$can('manage', 'all-content') || (data.item.role == 'pembimbing' && data.item.status_hasil_sidang_id != 4 && data.item.file_berita_acara != null)" -->
              <feather-icon icon="FileIcon" />
            </b-button>
            <b-modal :id="'modal-download-' + data.item.uuid" centered title="Download File" :hide-footer="true">
              <center>
                 <b-button class="mr-1 mt-2 btn" variant="outline-primary" title="Download Daftar Hadir"
                  v-if="data.item.status_hasil_sidang_id == 5"
                  @click="lihatBeritaAcara(data.item.file_daftar_hadir)"
                >
                Download Notulensi Sidang
                </b-button>
              </center>
              <center>
                 <b-button class="mr-1 mt-2 btn" variant="outline-primary" title="Download Berita Acara"
                  v-if="($can('all-content','manage') || data.item.role == 'pembimbing') && data.item.status_hasil_sidang_id == 5 && data.item.file_berita_acara != null"
                  @click="lihatBeritaAcara(data.item.file_berita_acara)"
                >
                Download Berita Acara dan Daftar Hadir
                </b-button>
              </center>
              <div class="d-flex justify-content-center mt-4">
                <b-button variant="primary" @click="$bvModal.hide('modal-download-' + data.item.uuid)">Tutup</b-button>
              </div>
            </b-modal>
          </div>           
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Tampilkan {{ dataMeta.from }} hingga {{ dataMeta.to }} dari {{ dataMeta.of }} entri</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalUsers"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, BFormTextarea, BModal,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import {
  deletePengajuanSidang,
  getStatusHasilSidang,
  updateStatusByAdmin,
  downloadBeritaAcara,
  buildBeritaAcara,
  postBatalkanUjian,
} from '@/connection-api/master'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { avatarText } from '@core/utils/filter'
import storeModule from '@/connection-api/hasil-sidang/storeModule'
import useList from '@/connection-api/hasil-sidang/list'
import listFilters from './ListFilters.vue'

export default {
  components: {
    listFilters,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    // BLink,
    BDropdown,
    BDropdownItem,
    BPagination,
    BBadge,

    vSelect,
    BFormTextarea,
    BModal,
  },
  data() {
    return {
      catatan_pembatalan: null,
      attr: null,
      status_hasil_sidang_id: null,
      statusHasilSidangOption: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Status Hasil Sidang --' },
        ],
      },
      lihatSebagaiOptions: {
        selected: 'id',
        options: [
          { value: null, label: '--Lihat Sebagai --' },
          { value: 'pembimbing', label: 'Pembimbing' },
          { value: 'penguji', label: 'Penguji' },
        ],
      },
    }
  },
  async mounted() {
    this.searchQuery = 'pembimbing'
    const userDataString = localStorage.getItem('userData')
    const userDataArray = JSON.parse(userDataString)
    this.attr = userDataArray.attr
  },
  beforeCreate() {
    getStatusHasilSidang()
    .then(response => {
    if (response.data.length > 0) {
      response.data.forEach(element => {
        this.statusHasilSidangOption.options.push({
          label: element.nama,
          value: element.uuid,
        })
      })
    }
    })
    .catch(error => console.log(error));
  },
  methods: {
    batalkanUjian(hasil_sidang_uuid, catatan) {
        var data = {
          hasil_sidang_uuid: hasil_sidang_uuid,
          catatan_pembatalan: catatan,
        }
        postBatalkanUjian(data)
        .then(response => {
          if (response.data.success == true) {
            this.refetchData()
            this.$bvModal.hide('modal-batalkan-ujian-' + data.hasil_sidang_uuid)
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Hasil Sidang',
                icon: 'CoffeeIcon',
                variant: 'success',
                text: 'Ujian Berhasil Dibatalkan',
              },
            })
          }
        })
        .catch(error => console.log(error));
    },
    async lihatBeritaAcara(filename) {
      downloadBeritaAcara(filename)
          .then(resp => {
            var type_file = filename.substring(filename.length - 4);
            if (type_file === ".pdf") {
              const fileURL = window.URL.createObjectURL(new Blob([resp.data]))
              const fileLink = document.createElement('a')

              fileLink.href = fileURL
              fileLink.setAttribute('download', filename)
              document.body.appendChild(fileLink)
              fileLink.click()
            }
          })
          .catch(error => {
          this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Hasil Sidang',
                icon: 'CoffeeIcon',
                variant: 'danger',
                text: 'Gagal Membuat File',
              },
            })
        });
    },
    async updateStatusHasilSidangByAdmin(uuid)
    {
      var data = {
        uuid: uuid,
        status_hasil_sidang_id: this.status_hasil_sidang_id,
      }
      const response = await updateStatusByAdmin(data)
        if(response.data.success === true){
          this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Hasil Sidang',
                icon: 'CoffeeIcon',
                variant: 'success',
                text: 'Data berhasil di hapus',
              },
            })
            this.$bvModal.hide(`bv-modal-admin-status${uuid}`)
            this.refetchData()
        }else{
          this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Hasil Sidang',
                icon: 'CoffeeIcon',
                variant: 'danger',
                text: 'Data gagal di hapus',
              },
            })
        }
    },
    async deleteData(id){
      if (confirm('Anda yakin ingin menghapus data ini?')) {
        // Save it!
        const response = await deletePengajuanSidang(id)
        if(response.data.success === true){
          this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Hasil Sidang',
                icon: 'CoffeeIcon',
                variant: 'success',
                text: 'Data berhasil di hapus',
              },
            })
            this.refetchData()
        }else{
          this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Hasil Sidang',
                icon: 'CoffeeIcon',
                variant: 'danger',
                text: 'Data gagal di hapus',
              },
            })
        }
      }
    },
    mappingSelectOption(master, name) {
      if (master.length > 0) {
        master.forEach(element => {
          name.push({
            label: element.nama,
            value: element.id,
          })
        })
      }
    },
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = 'hasil-sidang'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, storeModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    const isAddNewUserSidebarActive = ref(false)

    const {
      fetchDatas,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      triggerFilter,
      dataFilter,
    } = useList()

    return {

      // Sidebar
      isAddNewUserSidebarActive,

      fetchDatas,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      triggerFilter,
      dataFilter,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
